<template>
  <div>
    <div class="bottom-right" style="padding-right:15px;padding-top:0.1rem">
      <i @click="logout" class="primary fa fa-sign-out-alt fa-3x"/>
    </div>
  </div>
</template>

<style>
div.bottom-right {
position: absolute;
top: 0;
right: 0;
z-index: 1000;
}
</style>

<script>
export default {
  methods: {
    logout: function () {
      this.$cookie.delete('session_id')
      this.$router.push('/login')
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/layout/ContentFooter.vue